module.exports = __webpack_public_path__ + "img/801.38fe5bf0.png";